module.exports = __webpack_public_path__ + "img/checkin.2f30643f.png";